import { isCookiesAccepted } from 'react-wavecoder-components'

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

class GoogleAnalytics {
  private measurementId?: string;
  private initialised = false;

  public setMeasurementId(id: string) {
    this.measurementId = id;
  }

  public initialise() {
    if (!isCookiesAccepted()) {
      console.log('Analytics not initialized - no cookie consent');
      return;
    }

    if (this.initialised || !this.measurementId) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', this.measurementId, {
      send_page_view: false,
      anonymize_ip: true,
      allow_google_signals: false,
    });

    this.initialised = true;
  }

  public trackPageView(page: string, title?: string) {
    if (!this.initialised || !isCookiesAccepted()) return;

    window.gtag('config', this.measurementId, {
      page_path: page,
      page_title: title,
    });
  }

  public trackEvent(eventName: string, parameters?: Record<string, any>) {
    if (!this.initialised || !isCookiesAccepted()) return;

    window.gtag('event', eventName, parameters);
  }

  public trackCustomEvent(action: string, category: string, label?: string, value?: number) {
    this.trackEvent(action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }

  public initialiseWithConsent(measurementId: string) {
    this.setMeasurementId(measurementId);
    this.initialise();
  }

  public disable() {
    if (this.initialised && window.gtag) {
      window.gtag('config', this.measurementId, {
        send_page_view: false,
        transport_type: 'beacon',
        custom_map: {}
      });
      window.dataLayer = [];
    }

    this.initialised = false;
    console.log('Analytics disabled - user declined cookies');
  }

  public isInitialised(): boolean {
    return this.initialised;
  }
}

export const ga = new GoogleAnalytics();
export default ga;
